import React, { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  FaEdit,
  FaEye,
  FaImages,
  FaPlus,
  FaRegFileVideo,
  FaSave,
  FaSearch,
  FaTrash,
  FaUpload,
} from "react-icons/fa";
import AllFilePage from "./allFilePage";
import { elakayAutoText } from "../../pageInside/dataElakay";
import "./formPageLang1.css";

const emptyFileValue = {
  title: "",
  image: "",
  video: "",
  thumbnail: "",
  imagePath: "",
  videoPath: "",
  VORI: "",
};

const isPlainObject = (value) => value && typeof value === "object" && !Array.isArray(value);
const normalizeMediaType = (value) => (value === "image" || value === "video" ? value : "");
const cleanString = (value) => (value == null ? "" : String(value));
const MAX_UPLOAD_SIZE = 10 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = new Set(["image/jpeg", "image/png", "image/webp", "image/gif"]);

const normalizeFileItem = (value = {}) => ({
  ...emptyFileValue,
  ...(isPlainObject(value) ? value : {}),
  title: cleanString(value?.title),
  imagePath: cleanString(value?.imagePath),
  videoPath: cleanString(value?.videoPath),
  VORI: normalizeMediaType(value?.VORI),
});

const extractLanguageDoc = (data) => data?.frTxtLanguage || data?.language || data;

const getLanguageList = (doc, key) => (
  Array.isArray(doc?.[key]) ? doc[key] : []
);

const findSavedFileItem = (data, key, previousItem) => {
  if (isPlainObject(data?._updatedItem)) return data._updatedItem;
  const doc = extractLanguageDoc(data);
  const list = getLanguageList(doc, key);
  const previousId = cleanString(previousItem?._id);

  if (!list.length) return null;

  if (previousId) {
    const sameItem = list.find((item) => cleanString(item?._id) === previousId);
    if (sameItem) return sameItem;
  }

  const previousTitle = cleanString(previousItem?.title).trim().toLowerCase();
  if (previousTitle) {
    const sameTitle = [...list].reverse().find(
      (item) => cleanString(item?.title).trim().toLowerCase() === previousTitle
    );
    if (sameTitle) return sameTitle;
  }

  return list[list.length - 1] || null;
};

const StatusPill = ({ tone = "neutral", children }) => (
  <span className={`lang-file-pill lang-file-pill-${tone}`}>{children}</span>
);

const ActionButton = ({
  active = false,
  danger = false,
  disabled = false,
  icon,
  children,
  onClick,
  type = "button",
}) => (
  <button
    type={type}
    className={[
      "lang-file-action",
      active ? "is-active" : "",
      danger ? "is-danger" : "",
    ].filter(Boolean).join(" ")}
    disabled={disabled}
    onClick={onClick}
  >
    {icon}
    <span>{children}</span>
  </button>
);

const FieldLabel = ({ children }) => (
  <label className="lang-file-label">{children}</label>
);

const FormPageLang1 = (props) => {
  const {
    infoSource,
    editAdd,
    setEditAdd,
    ObjetPage,
    nameObj,
    token,
    AlllanguageSelect,
    languageUsertra,
    languageTradictor,
    updateLanguageElakay0,
    deleteLanguageElakay0,
    updateLanguageFileUp,
    buttonAddLanguage,
    setError: setParentError,
  } = props;

  const fileItems = useMemo(
    () => (Array.isArray(languageTradictor?.[nameObj]) ? languageTradictor[nameObj] : []),
    [languageTradictor, nameObj]
  );

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [viewPage, setViewPage] = useState(true);
  const [deletePara, setDeletePara] = useState(false);
  const [checkdeletePara, setCheckDeletePara] = useState(false);
  const [imageVideo, setImageVideo] = useState("");
  const [fileElakay, setFileElakay] = useState(() => normalizeFileItem(ObjetPage));
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const { title, video, image, imagePath, videoPath } = fileElakay;
  const selectedMediaType = normalizeMediaType(imageVideo || fileElakay.VORI);
  const selectedFile = selectedMediaType === "image" ? image?.file : video?.file;
  const hasExistingMedia = selectedMediaType === "image"
    ? Boolean(imagePath)
    : selectedMediaType === "video"
      ? Boolean(videoPath)
      : false;
  const currentItemId = cleanString(fileElakay?._id);
  const isEditMode = !editAdd;
  const selectedItemIndex = currentItemId
    ? fileItems.findIndex((item) => cleanString(item?._id) === currentItemId)
    : -1;

  const filteredItems = useMemo(() => {
    const needle = search.trim().toLowerCase();
    if (!needle) return fileItems;
    return fileItems.filter((item) => cleanString(item?.title).toLowerCase().includes(needle));
  }, [fileItems, search]);

  useEffect(() => {
    if (editAdd) {
      setFileElakay(normalizeFileItem(ObjetPage));
      setImageVideo("");
      return;
    }

    const selectedItem = currentItemId
      ? fileItems.find((item) => cleanString(item?._id) === currentItemId)
      : fileItems[0];

    if (selectedItem) {
      const nextItem = normalizeFileItem(selectedItem);
      setFileElakay(nextItem);
      setImageVideo(normalizeMediaType(nextItem.VORI));
    }
  }, [editAdd, fileItems, ObjetPage, currentItemId]);

  const txt = (key, fallback = "") => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.languageFormPageLang1?.[key];
    return typeof val === "string" ? val : fallback;
  };

  const formText = (key, fallback = "") => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.formPageLang1?.[key];
    return typeof val === "string" ? val : fallback;
  };

  const notifyError = (message) => {
    const nextMessage = message || elakayAutoText("h_07a60d48da3d25", "Une erreur inconnue est survenue.");
    setError(nextMessage);
    setSuccess("");
    if (setParentError) setParentError(nextMessage);
  };

  const notifySuccess = (message) => {
    setSuccess(message);
    setError("");
    if (setParentError) setParentError(null);
  };

  const refreshLanguageData = async () => {
    await Promise.all([
      Promise.resolve(AlllanguageSelect?.()),
      Promise.resolve(languageUsertra?.()),
    ]);
  };

  const startNewFile = () => {
    setEditAdd(true);
    setFileElakay(normalizeFileItem(ObjetPage));
    setImageVideo("");
    setCheckDeletePara(false);
    setDeletePara(false);
    setError("");
    setSuccess("");
  };

  const selectFileItem = (item) => {
    const nextItem = normalizeFileItem(item);
    setEditAdd(false);
    setFileElakay(nextItem);
    setImageVideo(normalizeMediaType(nextItem.VORI));
    setCheckDeletePara(false);
    setError("");
    setSuccess("");
  };

  const selectFirstForEdit = () => {
    if (!fileItems.length) {
      notifyError(elakayAutoText("h_932f30ae638ce2", "they is no data to edit"));
      return;
    }
    selectFileItem(fileItems[0]);
  };

  const handleLanguage = (event) => {
    const value = event.target.value;
    if (value === "") {
      startNewFile();
      return;
    }
    const nextItem = fileItems[Number(value)];
    if (nextItem) selectFileItem(nextItem);
  };

  const handleChange = (name) => (event) => {
    const value = event.target.value;
    setFileElakay((current) => ({ ...current, [name]: value }));
  };

  const handleVideoimage = (value) => {
    const nextMediaType = selectedMediaType === value ? "" : value;
    setImageVideo(nextMediaType);
    setFileElakay((current) => ({
      ...current,
      VORI: nextMediaType,
      image: nextMediaType === "image" ? current.image : "",
      video: nextMediaType === "video" ? current.video : "",
      thumbnail: "",
      imagePath: nextMediaType === "image" ? current.imagePath : "",
      videoPath: nextMediaType === "video" ? current.videoPath : "",
    }));
  };

  const handleFileChange = (name) => (event) => {
    const nextFile = event.target.files?.[0];
    if (!nextFile) return;

    const validType = name === "image"
      ? ALLOWED_IMAGE_TYPES.has(nextFile.type)
      : nextFile.type === "video/mp4";
    if (!validType) {
      event.target.value = "";
      notifyError(name === "image"
        ? elakayAutoText("h_f1928a76f798c2", "Format d'image non pris en charge (JPEG, PNG, WebP ou GIF).")
        : elakayAutoText("h_d666aa57aebc73", "Seules les vidéos MP4 sont acceptées."));
      return;
    }
    if (nextFile.size > MAX_UPLOAD_SIZE) {
      event.target.value = "";
      notifyError(elakayAutoText("h_586565f558500d", "Le fichier dépasse la taille maximale de 10 Mo."));
      return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", () => {
      const fileObject = {
        file: nextFile,
        name: nextFile.name,
        type: nextFile.type,
        size: nextFile.size,
        src: reader.result,
      };
      setFileElakay((current) => ({ ...current, [name]: fileObject }));
    });
    reader.addEventListener("error", () => {
      notifyError(elakayAutoText("h_b4240828abaf32", "Impossible de lire le fichier sélectionné."));
    });
    reader.readAsDataURL(nextFile);
  };

  const buildFilePayload = (item) => {
    const mediaType = normalizeMediaType(item.VORI || selectedMediaType);
    const payload = {
      title: cleanString(item.title).trim(),
      imagePath: mediaType === "image" ? cleanString(item.imagePath) : "",
      videoPath: mediaType === "video" ? cleanString(item.videoPath) : "",
      VORI: mediaType,
    };

    if (item._id) payload._id = item._id;
    return payload;
  };

  const canSubmit = () => {
    if (saving || deleting) return false;
    if (!cleanString(title).trim()) return false;
    if (!languageTradictor?._id || !token || !nameObj) return false;
    if (!selectedMediaType) return true;
    if (selectedFile || hasExistingMedia) return true;
    return false;
  };

  const saveMetaData = async () => {
    const payload = buildFilePayload(fileElakay);
    const data = await updateLanguageElakay0(
      languageTradictor._id,
      token,
      { [nameObj]: payload },
      true
    );

    if (data?.error || data?.success === false) {
      throw new Error(data.error || elakayAutoText("h_63d1e9d54c908b", "Impossible de sauvegarder."));
    }

    return normalizeFileItem(findSavedFileItem(data, nameObj, payload) || payload);
  };

  const saveMediaFile = async (savedItem) => {
    const mediaType = normalizeMediaType(selectedMediaType);
    if (!mediaType || !selectedFile) return savedItem;

    if (!savedItem?._id) {
      throw new Error(elakayAutoText("h_b2d9735338758c", "L'objet doit avoir un identifiant avant l'upload du fichier."));
    }

    const data = await updateLanguageFileUp(
      languageTradictor._id,
      savedItem._id,
      nameObj,
      token,
      selectedFile,
      mediaType,
      true
    );

    if (data?.error || data?.success === false) {
      throw new Error(data.error || elakayAutoText("h_8562a49c0b8c07", "Impossible d'uploader le fichier."));
    }

    return normalizeFileItem(findSavedFileItem(data, nameObj, savedItem) || savedItem);
  };

  const handleSubmit = async () => {
    if (!canSubmit()) return;

    setSaving(true);
    setError("");
    setSuccess("");

    const wasNewItem = !currentItemId;
    let savedItem = null;

    try {
      savedItem = await saveMetaData();
      const savedWithMedia = await saveMediaFile(savedItem);

      await refreshLanguageData();
      setFileElakay(savedWithMedia);
      setImageVideo(normalizeMediaType(savedWithMedia.VORI || selectedMediaType));
      setEditAdd(false);
      notifySuccess(elakayAutoText("h_a2c31117d64ac8", "Fichier sauvegardé."));
    } catch (saveError) {
      if (wasNewItem && selectedFile && savedItem?._id) {
        await deleteLanguageElakay0(
          languageTradictor._id,
          savedItem._id,
          nameObj,
          token,
          selectedMediaType,
          true
        ).catch(() => undefined);
      }
      notifyError(saveError.message);
    } finally {
      setSaving(false);
    }
  };

  const buttonDelPara = async () => {
    if (!currentItemId || !checkdeletePara || deleting) return;

    setDeleting(true);
    setError("");
    setSuccess("");

    try {
      const mediaType = normalizeMediaType(fileElakay.VORI || imageVideo) || undefined;
      const data = await deleteLanguageElakay0(
        languageTradictor._id,
        currentItemId,
        nameObj,
        token,
        mediaType,
        true
      );

      if (data?.error || data?.success === false) {
        throw new Error(data.error || elakayAutoText("h_8c855d23a86731", "Impossible de supprimer."));
      }

      await refreshLanguageData();
      startNewFile();
      notifySuccess(elakayAutoText("h_09f51c7062ed0a", "Fichier supprimé."));
    } catch (deleteError) {
      notifyError(deleteError.message);
    } finally {
      setDeleting(false);
    }
  };

  const renderMediaChoice = (type, icon, label) => (
    <button
      type="button"
      className={`lang-file-media-choice ${selectedMediaType === type ? "is-active" : ""}`}
      onClick={() => handleVideoimage(type)}
    >
      {icon}
      <span>{label}</span>
    </button>
  );

  const deleteAgree = () => (
    <Modal
      show={deletePara}
      onHide={() => setDeletePara(false)}
      dialogClassName="modal-90w"
      aria-labelledby="del-modal-lang1"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="del-modal-lang1">
          {infoSource.language(infoSource, "title", "delThtems")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="lang-file-delete-preview">
          <AllFilePage
            infoSource={infoSource}
            classAlert={elakayAutoText("h_3e094ebf1a427f", "alert alert-success")}
            classImg="col-12"
            paragra={fileElakay}
            paragra0={fileItems}
            paraALLBoo
          />
        </div>

        <label className="lang-file-confirm-row" htmlFor="chButAgreeLang1">
          <input
            onChange={() => setCheckDeletePara(!checkdeletePara)}
            type="checkbox"
            checked={checkdeletePara}
            id="chButAgreeLang1"
          />
          <span>{infoSource.language(infoSource, "title", "chButAgree")}</span>
        </label>

        <div className="lang-file-modal-actions">
          <button
            type="button"
            className="lang-file-delete-button"
            disabled={!checkdeletePara || deleting}
            onClick={buttonDelPara}
          >
            <FaTrash aria-hidden="true" />
            <span>{deleting ? elakayAutoText("h_3078a3697e4b64", "Suppression...") : txt("t005", "Delete this param")}</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );

  return (
    <div className="lang-file-manager">
      <header className="lang-file-toolbar">
        <div className="lang-file-title-block">
          <span className="lang-file-kicker">{elakayAutoText("h_6e83d50f6d5596", "Fichiers Elakay")}</span>
          <h2>{txt("t007", "Form to edit / add menu Head")}</h2>
        </div>
        <div className="lang-file-toolbar-actions">
          <StatusPill tone={isEditMode ? "info" : "success"}>
            {isEditMode ? elakayAutoText("h_f0698f621dc0a2", "Modification") : elakayAutoText("h_a6389bc7c4a199", "Nouveau")}
          </StatusPill>
          <StatusPill>{elakayAutoText("h_7ea8fdc5e40b48", "{value0} objet(s)", { value0: fileItems.length })}</StatusPill>
          <ActionButton active={editAdd} icon={<FaPlus aria-hidden="true" />} onClick={startNewFile}>
            {elakayAutoText("h_99ea63812716ac", "Ajouter")}
          </ActionButton>
          <ActionButton active={!editAdd} icon={<FaEdit aria-hidden="true" />} onClick={selectFirstForEdit}>
            {elakayAutoText("h_70a0c2b5eb8d88", "Modifier")}
          </ActionButton>
        </div>
      </header>

      {(error || success) && (
        <div className={`lang-file-alert ${error ? "is-error" : "is-success"}`}>
          <span>{error || success}</span>
        </div>
      )}

      <div className="lang-file-workspace">
        <aside className="lang-file-list-panel">
          <div className="lang-file-search">
            <FaSearch aria-hidden="true" />
            <input
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder={elakayAutoText("h_62203e926a21cc", "Rechercher un fichier")}
              type="search"
            />
          </div>

          <select
            className="lang-file-select"
            value={selectedItemIndex >= 0 ? String(selectedItemIndex) : ""}
            onChange={handleLanguage}
          >
            <option value="">{txt("t001", "select")}</option>
            {fileItems.map((item, index) => (
              <option key={item?._id || index} value={index}>
                {cleanString(item?.title) || elakayAutoText("h_93ef06458d793f", "Objet {value0}", { value0: index + 1 })}
              </option>
            ))}
          </select>

          <div className="lang-file-list">
            {filteredItems.length > 0 ? filteredItems.map((item, index) => {
              const itemId = cleanString(item?._id);
              const active = itemId && itemId === currentItemId;
              const mediaType = normalizeMediaType(item?.VORI);
              return (
                <button
                  type="button"
                  className={`lang-file-list-item ${active ? "is-active" : ""}`}
                  key={itemId || index}
                  onClick={() => selectFileItem(item)}
                >
                  <span className="lang-file-list-icon">
                    {mediaType === "video" ? <FaRegFileVideo aria-hidden="true" /> : <FaImages aria-hidden="true" />}
                  </span>
                  <span className="lang-file-list-text">
                    <strong>{cleanString(item?.title) || elakayAutoText("h_93ef06458d793f", "Objet {value0}", { value0: index + 1 })}</strong>
                    <small>{mediaType || elakayAutoText("h_65d1e7b8203a45", "Aucun")}</small>
                  </span>
                </button>
              );
            }) : (
              <p className="lang-file-empty">{elakayAutoText("h_a3c8c5f75d704b", "Aucun fichier trouvé.")}</p>
            )}
          </div>
        </aside>

        <section className="lang-file-editor-panel">
          <div className="lang-file-panel-head">
            <h3>{txt("t009", "Title")}</h3>
            {currentItemId && (
              <button
                type="button"
                className="lang-file-danger-link"
                onClick={() => setDeletePara(true)}
                disabled={saving || deleting}
              >
                <FaTrash aria-hidden="true" />
                <span>{txt("t008", "Delete this param")}</span>
              </button>
            )}
          </div>

          <div className="lang-file-field">
            <FieldLabel>{txt("t009", "Title")}</FieldLabel>
            <input
              onChange={handleChange("title")}
              type="text"
              value={title}
              placeholder={formText("t001", "enter your the title")}
              className="lang-file-input"
            />
          </div>

          <div className="lang-file-section-title">{elakayAutoText("h_0c77aeece8c258", "Media")}</div>
          <div className="lang-file-media-grid">
            {renderMediaChoice("image", <FaImages aria-hidden="true" />, txt("t004", "Add image"))}
            {renderMediaChoice("video", <FaRegFileVideo aria-hidden="true" />, txt("t003", "Add video"))}
          </div>

          {selectedMediaType === "image" && (
            <div className="lang-file-upload-box">
              <FieldLabel>{txt("t012", "Add images")}</FieldLabel>
              <input onChange={handleFileChange("image")} type="file" name="image" accept="image/*" />
              {image?.name && <span className="lang-file-file-name">{image.name}</span>}
            </div>
          )}

          {selectedMediaType === "video" && (
            <div className="lang-file-upload-box">
              <FieldLabel>{txt("t010", "Add a video")}</FieldLabel>
              <input onChange={handleFileChange("video")} type="file" accept="video/mp4,video/*" name="video" />
              {video?.name && <span className="lang-file-file-name">{video.name}</span>}
            </div>
          )}

          <div className="lang-file-current-media">
            <span>{elakayAutoText("h_7f957f95ef2d3b", "Média actuel")}</span>
            <strong>{selectedMediaType || elakayAutoText("h_65d1e7b8203a45", "Aucun")}</strong>
          </div>

          {(imagePath || videoPath) && (
            <div className="lang-file-paths">
              {imagePath && <code>{imagePath}</code>}
              {videoPath && <code>{videoPath}</code>}
            </div>
          )}

          <div className="lang-file-save-row">
            <span className="lang-file-save-state">
              {saving ? (
                <>
                  <FaUpload aria-hidden="true" />
                  {elakayAutoText("h_23b62b065bd544", "Sauvegarde...")}
                </>
              ) : (
                <>
                  <FaSave aria-hidden="true" />
                  {elakayAutoText("h_a055947cafbf25", "Prêt")}
                </>
              )}
            </span>
            {buttonAddLanguage(handleSubmit, canSubmit())}
          </div>
        </section>

        <section className="lang-file-preview-panel">
          <div className="lang-file-panel-head">
            <h3>{elakayAutoText("h_a62da9010119c1", "Live Preview")}</h3>
            <ActionButton
              active={viewPage}
              icon={<FaEye aria-hidden="true" />}
              onClick={() => setViewPage(!viewPage)}
            >
              {viewPage
                ? infoSource.laguangeElakay("title", infoSource.languageAPI).viewAll
                : infoSource.laguangeElakay("title", infoSource.languageAPI).viewPage}
            </ActionButton>
          </div>

          <div className="lang-file-preview-shell">
            <AllFilePage
              infoSource={infoSource}
              classAlert={elakayAutoText("h_3e094ebf1a427f", "alert alert-success")}
              classImg="col-12"
              classPara="col-12"
              paragra={fileElakay}
              paragra0={fileItems}
              paraALLBoo={viewPage}
            />
          </div>
        </section>
      </div>

      {deleteAgree()}
    </div>
  );
};

export default FormPageLang1;
